import { useContext } from "react";
import { useHistory } from "react-router";
import { MenuItem } from "@remo-co/ui-core/src/components/MenuItem";
import { Copy01 as Copy01Icon } from "@remo-co/ui-core/src/icons/Copy01";
import { useI18n } from "i18n";
import { useSelector } from "react-redux";
import { selectUserId } from "modules/auth/redux/selectors";
import { Events, TRACKING_CONTEXT } from "modules/tracking";
import useAuth from "modules/auth/hooks/useAuth";
import { useAppDispatch } from "store/hooks";
import { addDialogNotification } from "modules/dialogNotification/redux/dialogNotificationSlice";

interface CloneEventButtonProps {
  handleClose: () => void;
  eventId: string;
  className?: string;
  eventType?: string;
}

const CloneEventButton = ({
  handleClose,
  eventId,
  className,
  eventType,
}: CloneEventButtonProps) => {
  const { isEventHelper } = useAuth();
  const dispatch = useAppDispatch();
  const { t } = useI18n(["common", "event", "manageEvent", "eventForm"]);
  const { push } = useHistory();
  const { track } = useContext(TRACKING_CONTEXT);

  const userId = useSelector(selectUserId);

  const getCloneContent = () => (
    <div>
      {t("event:warning")}
      <ul style={{ textAlign: "left" }}>
        <li>{t("event:time")}</li>
        <li>{t("event:speakers")}</li>
        <li>{t("event:content.banners")}</li>
        <li>{t("event:attendees")}</li>
        <li>{t("manageEvent:event.assistants")}</li>
        <li>{t("common:chat.button")}</li>
        <li>{t("manageEvent:stream")}</li>
        <li>{t("eventForm:custom.registration.questions")}</li>
        <li>{t("eventForm:networking.recommendations")}</li>
        <li>{t("eventForm:email.customizations")}</li>
      </ul>
    </div>
  );
  const handleDuplicateEvent = () => {
    if (userId) {
      track(Events.CLONE_EVENT_CLICKED, { eventId, userId, eventType });
    }
    dispatch(
      addDialogNotification({
        title: t("event:clone.event"),
        message: "",
        content: getCloneContent(),
        onConfirm: () => {
          push(`/event/settings/${eventId}?clone=1`);
        },
        confirmText: t("event:clone.event"),
        confirmTestId: "confirm-clone-event",
        dismissText: t("event:cancel"),
        confirmVariant: "secondary",
        lightDialog: true,
      }),
    );

    handleClose();
  };

  if (isEventHelper) {
    return null;
  }

  return (
    <MenuItem
      onClick={handleDuplicateEvent}
      data-testid="ev-clone"
      disabled={false}
      className={className}
    >
      <Copy01Icon />
      {t("event:clone.this.event")}
    </MenuItem>
  );
};

export default CloneEventButton;
